import Api from 'utils/api'
import * as actions from './actions'

// houses

export const getHouses =
  ({ parentUuid, q }) =>
  async (dispatch) => {
    dispatch(actions.getHousesRequest())
    try {
      const setParams = () => {
        let params = []

        if (parentUuid) params.push(`parent_uuid=${parentUuid}`)
        if (q) params.push(`q=${q}`)

        params = params.join('&')

        return params.length > 0 ? `?${params}` : params
      }

      const houses = await Api.request(`/houses${setParams()}`)

      dispatch(actions.getHousesSuccess(houses))
    } catch (err) {
      const { message } = await err.json()
      dispatch(actions.getHousesError(message))
    }
  }

export const fetchHouse = (houseUuid) => async (dispatch) => {
  dispatch(actions.fetchHouseRequest())
  try {
    const house = await Api.request(`/houses/${houseUuid}`)

    dispatch(actions.fetchHouseSuccess(house))
  } catch (err) {
    const { message } = await err.json()
    dispatch(actions.fetchHouseFailure(message))
  }
}
